import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ImgBox } from 'views/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/tours-module/ToursLandingViewV2/components/HeroSection/HeroSection.styles';
import dynamic from 'next/dynamic';
import { MainWidgetV2 } from 'views/rebranded-module/common/components';
import { WIDGET_TYPES } from 'views/rebranded-module/common/components/Logical/MainWidgetV2/utils/constants';
import { useContent } from 'views/rebranded-module/common/context/useContent';
// import PATHS from 'lib/navigation/paths';
// import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
// import { REFS } from 'views/rebranded-module/common/utils/constants';

const BookNowOverlay = dynamic(() => import('views/rebranded-module/HomeViewV2/components/UI/BookNowOverlay').then(
  (file) => file.BookNowOverlay,
));
const HeroSection = (props) => {
  const { initWidgetData } = props;
  const content = useContent('ToursLandingPage');
  // const tourLandingRef = REFS.MOTORCYCLE_TOUR_LANGING;
  const getSizedImage = useAdabtiveMultiSizeImage();
  const [isOverlayOpen, setOverlayOpen] = useState(false);
  const handleOpenOverlayBookingClick = (event) => {
    setOverlayOpen(true);
    event.currentTarget.blur(); // Remove focus immediately after click
  };

  const heroImage = {
    large_url: content.heroBackground?.url,
    medium_url: content.heroBackground?.url,
    small_url: content.heroBackgroundMobile?.url,
    alt: content.heroBackground?.alt || content.heroBackgroundMobile?.alt,
  };

  const heroImgSrc = getSizedImage(heroImage);

  return (
    <StyledBox>
      <Box className="HSBGContainer">
        {heroImgSrc ? (
          <ImgBox
            image={{ src: heroImgSrc, alt: heroImage.alt }}
            data-src={heroImgSrc}
            imgHeight="100%"
            imgWidth="100%"
            imgObjectFit="cover"
            unoptimized
          />
        ) : null}
        <Box className="HSBGGradient" />
      </Box>

      <Box className="HSContentContainer">
        <Typography variant="h2" component="h1" pb={2}>
          {content.heroTitle}
        </Typography>
        <Box display="flex" justifyContent="center" pb={2}>
          <Typography
            variant="body2"
            component="p"
            dangerouslySetInnerHTML={{ __html: content.heroSubtitle }}
          />
        </Box>
        <Box className="HSWidgetContainer">
          <MainWidgetV2
            rentalWidgetInitData={initWidgetData}
            initialWidgetType={WIDGET_TYPES.TOUR}
          />
        </Box>
        {/* <Button
          component={NavigatorLink}
          variant="contained"
          size="large"
          href={PATHS.motorcycleTours.listing({
            ref: tourLandingRef,
          })}>
          {content.heroButtonText}
        </Button> */}
      </Box>
      <Button
        variant="contained"
        color="primary"
        size="large"
        className="HSFixedButton"
        onClick={handleOpenOverlayBookingClick}>
        {content.completedButtonText}
      </Button>
      {isOverlayOpen && (
        <BookNowOverlay
          initialWidgetType={WIDGET_TYPES.TOUR}
          open={isOverlayOpen}
          onClose={() => setOverlayOpen(false)}
        />
      )}
    </StyledBox>
  );
};

export { HeroSection };
